<script setup lang="ts">
onMounted(() => {
  document.body.classList.add('_loaded');
})
</script>
<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
